import { logger } from 'lib/logger';
import { BillingDataAPI } from 'reactApp/api/billing/data/BillingDataAPICall';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { sendXray } from 'reactApp/utils/ga';
import { captureException } from 'reactApp/utils/tracer';
import { call, cancel, put, race, select, take, takeEvery } from 'typed-redux-saga';

import { pastSubscriptionsFailure, pastSubscriptionsRequest, pastSubscriptionsSuccess } from './pastSubscriptions.module';
import { PastSubscriptionsSelectors } from './pastSubscriptions.selectors';

export function* handlePastSubscriptionsRequest() {
    const isUserWithBilling = yield* select(UserSelectors.isUserWithBilling);
    if (!isUserWithBilling) {
        yield cancel();
    }

    try {
        sendXray(['billingData', 'past', 'request']);
        const data = yield* call(BillingDataAPI.past);
        if (!data) {
            sendXray(['billingData', 'past', 'request', 'empty', 'error']);
            logger.error('no past billing data from api');
            captureException('no past billing data from api', { issueKey: 'billingData/past/empty' });
            yield cancel();
        }
        sendXray(['billingData', 'past', 'request', 'success']);
        yield put(pastSubscriptionsSuccess({ billingData: data }));
    } catch (error) {
        sendXray(['billingData', 'past', 'request', 'error']);
        logger.error(error);
        captureException(error, { issueKey: 'billingData/past/error' });
        yield put(pastSubscriptionsFailure());
        yield cancel();
    }
}

export function* handlePastSubscriptionsSuccess() {
    const { isLoaded, isLoading } = yield select(PastSubscriptionsSelectors.getLoadingState);

    if (isLoaded && !isLoading) {
        return true;
    }

    const { success } = yield race({
        success: take(pastSubscriptionsSuccess.toString()),
        fail: take(pastSubscriptionsFailure.toString()),
    });

    return !!success;
}

export function* watchPastSubscriptionsRoot() {
    yield takeEvery(pastSubscriptionsRequest.toString(), handlePastSubscriptionsRequest);
}
